<template>
  <div justify="center">
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="600px"
      scrollable
    >
      <v-form ref="travelsDialogForm">
        <v-card>
          <v-card-title>
            <span class="travels-dialog__title">
              <span class="text-h5">{{year}}</span>年
              <span class="text-h5">{{month}}</span>月
              <span class="text-h5">{{day}}</span>日
              ({{common.week[common.select.dayOfWeek]}})
            </span>
            <v-spacer></v-spacer>
            <v-icon right @click="remove()">
              mdi-trash-can-outline
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="mt-1 pb-2">
            外出旅費
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4">
                  <v-text-field
                    v-model="discription"
                    label="用件"
                    prepend-icon="mdi-calendar-edit"
                    :rules="rules"
                    dense>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4">
                  <v-text-field
                    v-model="transportation"
                    label="交通手段"
                    prepend-icon="mdi-train-car"
                    :rules="rules"
                    dense
                    >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4">
                  <v-text-field
                    v-model="startSection"
                    label="出発地"
                    prepend-icon="mdi-alpha-s-box-outline"
                    :rules="rules"
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12"
                  sm="6"
                  md="4">
                  <v-text-field
                    v-model="endSection"
                    label="目的地"
                    prepend-icon="mdi-alpha-g-box-outline"
                    :rules="rules"
                    dense>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div style="display: flex; justify-content: flex-end;">
                    <v-switch
                      v-model="sectionType"
                      :label="sectionType ? '往復' : '片道'"
                      inset
                      dense
                    ></v-switch>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="amount"
                    label="料金"
                    prepend-inner-icon="mdi-currency-jpy"
                    type="number"
                    dense
                    outlined
                    clearable>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="common.color.primary"
              text
              @click="isOpen = false"
            >
              キャンセル
            </v-btn>
            <v-btn
              :color="common.color.primary"
              text
              @click="save()"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ["common", "data", "dialog"],
    data: () => ({
      isOpen: false,
      year: null,
      month: null,
      day: null,
      accountTitle: "交通費",
      discription: null,
      transportation: null,
      startSection: null,
      endSection: null,
      sectionType: false,
      amount: null,
      rules: [
        value => !!value || 'Required.',
      ],      
    }),
    methods: {
      initialize() {
        this.common.eventBus.$emit('App.overflow.remove')
        if (this.$refs.travelsDialogForm) {
          this.$refs.travelsDialogForm.resetValidation()
        }
        this.year = this.dialog.year
        this.month = this.dialog.month
        this.day = this.dialog.day
        this.id = this.dialog.travel.id
        this.discription = this.dialog.travel.discription
        this.transportation = this.dialog.travel.transportation
        this.startSection = this.dialog.travel.startSection
        this.endSection = this.dialog.travel.endSection
        this.sectionType = this.dialog.travel.sectionType == "1" ? true : false
        this.amount = this.dialog.travel.amount
        this.isOpen = true
      },
      save() {
        let isSuccess = this.$refs.travelsDialogForm.validate()
        if (isSuccess) {
          let date = this.getCurrentDate()
          let travel = {
            id: this.id,
            date: date,
            accountTitle: this.accountTitle,
            discription: this.discription,
            transportation: this.transportation,
            startSection: this.startSection,
            endSection: this.endSection,
            sectionType: this.sectionType ? 1 : 0,
            amount: this.amount ? Number(this.amount) : 0,
          }
          new Promise((resolve) => {
            let promise = []
            promise.push(this.setTravel(travel))
            promise.push(this.setTravelsHistory(travel))
            let sameTravel = this.getSameTravelsHistory(travel)
            if (sameTravel) {
              promise.push(this.deleteTravelsHistory(sameTravel.id))
            }
            Promise.all(promise)
            .then(() => {
              this.isOpen = false
              this.common.select.day = undefined
              this.common.select.day = this.day
              this.common.eventBus.$emit('App.reload')
              resolve()
            })
            .catch(err => {
              this.errorProcess(err)
            })
          })

        }
      },
      remove() {
        this.deleteTravel(this.id)
        .then(() => {
          this.isOpen = false
          this.common.eventBus.$emit('App.reload')
        })
        .catch(err => {
          this.errorProcess(err)
        })
      },
      getCurrentDate() {
        return moment(new Date(this.year, this.month - 1, this.day))
      },
    },
    created() {
      this.common.eventBus.$on('TravelsDialog.open', this.initialize)
    },
}
</script>

<style scoped>
  .travels-dialog__title {
    font-size: medium;
  }
</style>
